import { EcsActionType } from "../actions";
export function localSelectStateReducer(state = {}, action) {
    switch (action.type) {
        case EcsActionType.UpdateAttributeValue: {
            if (action.payload.isMultiValued) {
                return state;
            }
            const { attributePath, value, valueSelected } = action.payload;
            const nextState = Object.assign({}, state);
            if (valueSelected) {
                nextState[attributePath] = value;
            }
            else {
                delete nextState[attributePath];
            }
            return nextState;
        }
        case EcsActionType.ReplaceConfiguration:
            // reset all the local assignments
            return {};
        case EcsActionType.ResetAll:
            return {};
        default:
            return state;
    }
}
//# sourceMappingURL=localSelectStateReducer.js.map